import { render, staticRenderFns } from "./FulfillmentGrid.vue?vue&type=template&id=018c2cef&"
import script from "./FulfillmentGrid.vue?vue&type=script&lang=ts&"
export * from "./FulfillmentGrid.vue?vue&type=script&lang=ts&"
import style0 from "./FulfillmentGrid.vue?vue&type=style&index=0&id=018c2cef&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports